import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NavLangStackEditor from './NavLangStackEditor';
import { missingLangs } from './navEditorState';

// The city's meta band, laid out like the rendered dropdown header:
// big title, mono caption, black CTA chip, underlined home link.
// Clicking any of them opens the all-languages editor card below.
const NavCityHeader = ({ city, onChange, onDelete }) => {
  const [open, setOpen] = useState(null);
  const toggle = field => setOpen(open === field ? null : field);
  const cta = city.cta || {};
  const homeLink = city.homeLink || {};

  return (
    <div>
      <div className="mnv-cityhead">
        <button type="button" className="mnv-citytitle" title="Edit title (all languages)" onClick={() => toggle('title')}>
          {(city.title && city.title.en) || city.key || '(new city)'}
          {missingLangs(city.title).length > 0 && <i className="mnv-dot" title="missing translations" />}
        </button>
        <button type="button" className="mnv-citycaption" title="Edit caption (all languages)" onClick={() => toggle('caption')}>
          {(city.caption && city.caption.en) || 'caption — date · venue'}
          {missingLangs(city.caption).length > 0 && <i className="mnv-dot" title="missing translations" />}
        </button>
        <button type="button" className="mnv-ctachip" title="Edit CTA button" onClick={() => toggle('cta')}>
          {(cta.text && cta.text.en) || 'CTA'}
        </button>
        <button type="button" className="mnv-homelink" title="Edit home link" onClick={() => toggle('home')}>
          {`> ${(homeLink.text && homeLink.text.en) || 'home link'}`}
        </button>
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className="mnv-keyfield">
          <span className="mnv-lab">key</span>
          <input
            type="text"
            className="mnv-input mnv-input--mono"
            placeholder="barcelona"
            value={city.key || ''}
            onChange={e => onChange({ ...city, key: e.target.value })}
          />
        </label>
        <div className="mnv-cityhead-tools">
          {/* eslint-disable-next-line jsx-a11y/label-has-for */}
          <label className="mnv-check">
            <input
              type="checkbox"
              checked={city.visible !== false}
              onChange={() => onChange({ ...city, visible: city.visible === false })}
            />
            visible
          </label>
          <button
            type="button"
            className="mnv-delete"
            onClick={() => {
              // eslint-disable-next-line no-alert
              if (window.confirm(`Delete city "${city.key || 'new'}" and all its columns?`)) onDelete();
            }}
          >
            delete city
          </button>
        </div>
      </div>
      {open === 'title' && (
        <NavLangStackEditor
          label="City title"
          text={city.title}
          onChangeText={title => onChange({ ...city, title })}
          onDone={() => setOpen(null)}
        />
      )}
      {open === 'caption' && (
        <NavLangStackEditor
          label="Caption (date · venue)"
          text={city.caption}
          onChangeText={caption => onChange({ ...city, caption })}
          onDone={() => setOpen(null)}
        />
      )}
      {open === 'cta' && (
        <NavLangStackEditor
          label="CTA button"
          text={cta.text}
          onChangeText={t => onChange({ ...city, cta: { ...cta, text: t } })}
          url={cta.url}
          onChangeUrl={u => onChange({ ...city, cta: { ...cta, url: u } })}
          urlPlaceholder="/barcelona/tickets-barcelona"
          onDone={() => setOpen(null)}
        />
      )}
      {open === 'home' && (
        <NavLangStackEditor
          label="Home link"
          text={homeLink.text}
          onChangeText={t => onChange({ ...city, homeLink: { ...homeLink, text: t } })}
          url={homeLink.url}
          onChangeUrl={u => onChange({ ...city, homeLink: { ...homeLink, url: u } })}
          urlPlaceholder="/barcelona"
          onDone={() => setOpen(null)}
        />
      )}
    </div>
  );
};

NavCityHeader.propTypes = {
  city: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default NavCityHeader;
